import { PageTitle } from 'components';
import React, { FC, memo } from 'react';
import ActivityGlance from '../components/ActivityGlance';
import Challenge from '../components/Challenge';
import Community from '../components/Community';
import ConversationsFeedback from '../components/ConversationsFeedback';
import Intro from '../components/Intro';
import PremiumBanner from '../components/PremiumBanner';
import PremiumResources from '../components/PremiumResources';
import SignOff from '../components/SignOff';
import { Card, Content, Logo, Page } from '../styles';
import { Props } from './types';

/*
 * Presentational monthly report. Receives the report payload and the premium
 * flag as props so it can be driven both by the live container (real fetch) and
 * by the preview routes (mocked variants). Premium resource sub-sections still
 * fetch their own (global) data via their own connect.
 */
const ReportView: FC<Props> = ({
  className,
  isPremium,
  premiumResources,
  report,
}) => (
  <Page className={className}>
    <PageTitle title="Monthly report" />
    <Card>
      <Logo />
      <Content>
        <Intro
          firstName={report.user.firstName}
          periodLabel={report.periodLabel}
        />
        <ActivityGlance activity={report.activity} />
        <Challenge
          challenge={report.challenge}
          periodLabel={report.periodLabel}
        />
        <Community connections={report.connections} network={report.network} />
        <ConversationsFeedback
          conversations={report.recentConversations}
          feedback={report.recentFeedback}
        />
        {isPremium && (premiumResources ?? <PremiumResources />)}
        {!isPremium && <PremiumBanner />}
        <SignOff />
      </Content>
    </Card>
  </Page>
);

export default memo(ReportView);
